import { render, staticRenderFns } from "./StorageMng.vue?vue&type=template&id=3be4efc7"
import script from "./StorageMng.vue?vue&type=script&lang=js"
export * from "./StorageMng.vue?vue&type=script&lang=js"
import style0 from "./StorageMng.vue?vue&type=style&index=0&id=3be4efc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports